<ul class="list-group list-group-lg list-group-flush list my-n4 picklist ">
  <ng-container *ngFor="let data of cardData; index as idx;">
    <li class="list-group-item" appPickListCard [parentForm]="parentForm" [controlName]="controlName" [cardData]="data"></li>
  </ng-container>
</ul>
